<template>
  <div class="loader" v-if="isLoading"></div>
  <div v-else class="page">
    <div class="loader loader--overlay" v-if="isChangeTab"></div>

    <div>
      <img class="icon icon--link icon--bottom" src="~/images/arrow-left.svg" v-svg-inline>
      <router-link :to="backRoute()">Вернуться назад</router-link>
    </div>

    <header class="page-header">
      <h1 class="page-header__title">
        {{ campaign.name }}
      </h1>

    </header>

    <div class="page__content--column page__content">
      <tab-filter
        :items="edu_forms"
        :active-item="activeItem"
        :onChange="onSelectEduForm"
      />

      <div>
        <div class="page__generated">Данные на <b>{{ formattedDate }}</b></div>
        <div class="page__time-zone">Россия, Томск (UTC +7)</div>
        <component :is="resolveComponent()"></component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import TabFilter from '@main/components/TabFilter.vue'
import Aspirant from './_Aspirant.vue'
import Bachelor from './_Bachelor.vue'
import BachelorAdditional from './_BachelorAdditional.vue'
import Magistrant from './_Magistrant.vue'
import MagistrantAdditional from './_MagistrantAdditional.vue'
import educationLevel from '@main/mixins/education_level'

export default {
  components: { TabFilter, Aspirant, Bachelor, BachelorAdditional, Magistrant, MagistrantAdditional },
  mixins: [educationLevel],
  data: () => ({
    isLoading: false,
    isChangeTab: false
  }),
  computed: {
    activeItem() {
      return this.edu_forms.find(item => item.value === this.$route.params.edu_form)
    },
    formattedDate() {
      return this.$dayjs(this.generated_at, 'DD.MM.YYYY HH:mm:ss').format('D MMMM YYYY HH:mm')
    }
  },
  async created() {
    this.isLoading = true
    await this.getEducationLevel({
      education_level: this.$route.params.education_level,
      edu_form: this.$route.params.edu_form
    })
    this.isLoading = false
  },
  methods: {
    resolveComponent() {
      const level = this.$route.params.education_level
      return level.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
    },
    async onSelectEduForm(item) {
      if (item.value === this.$route.params.edu_form) return

      this.isChangeTab = true
      this.$router.push({ params: { edu_form: item.value } })

      await this.getEducationLevel({
        education_level: this.$route.params.education_level,
        edu_form: item.value
      })
      this.isChangeTab = false
    },
    backRoute() {
      return { name: 'campaigns' }
    }
  }
}
</script>